import $ from 'jquery';
import { getState } from '~src/state';

export const loadSelectTagsBackground = (backgroundItemId) => {
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');
  const allTags = window.editorConfig.sidebarTags.items;

  let data;
  if (backgroundItemId) {
    const backgroundItem = window.editorConfig.sidebarBackgrounds[
      currentTag
    ].items.find((item) => item.objectId === backgroundItemId);

    data = allTags.map((tag) => {
      return {
        id: tag.objectId,
        text: tag.name,
        disabled: backgroundItem.tags.some(
          (imageTag) => imageTag.objectId === tag.objectId
        ),
      };
    });
  } else {
    data = allTags.map((tag) => {
      return {
        id: tag.objectId,
        text: tag.name,
      };
    });
  }

  [
    '#tagBackgroundSelect',
    '#tagBackgroundSelectUpload',
    '#select-ricerca-backgrounds',
  ].forEach((selector) => {
    const isSelect2Init = $(selector).data('select2-id');
    if (!isSelect2Init) {
      $(selector).select2({
        data,
        tags: false,
        allowClear: true,
        width: '100%',
        theme: 'bootstrap4',
        placeholder: 'Seleziona un tag',
      });
    }
  });
};
